var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"block text-sm font-medium text-gray-700"},[_vm._v("Status")]),_vm._v(" "),_c('select-menu',{attrs:{"text":_vm.text,"values":_vm.values},model:{value:(_vm.local),callback:function ($$v) {_vm.local=$$v},expression:"local"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }